import Swiper from 'swiper/bundle';

function tabsSliderInit() {
	

	if (window.innerWidth < 639) {
		const swiperContainer = document.querySelector('.js-tabs-slider');
		const activeSlide = swiperContainer.querySelector('.swiper-slide.active');
		let initialSlideIndex = 0;

		if (activeSlide) {
			const slides = Array.from(
				swiperContainer.querySelectorAll('.swiper-slide'),
			);
			initialSlideIndex = slides.indexOf(activeSlide);
		}

		const swiperConfig = {
			speed: 1000,
			slidesPerView: 3,
			spaceBetween: 4,
			initialSlide: initialSlideIndex,
		};

		if (initialSlideIndex !== 0) {
			swiperConfig.centeredSlides = true;
		}

		const swiper = new Swiper(swiperContainer, swiperConfig);
	}
}

export default tabsSliderInit;
